import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from '../static/styles/BundleSplash.module.css';

const CONGRATS = 'congrats';
const SPLASH = 'splash';

const CONGRATS_MAX_MS = 15000;

const BundleSplash = ({ bundle, onContinue }) => {
    const videoRef = useRef(null);
    const [phase, setPhase] = useState(bundle.congratsVideo ? CONGRATS : SPLASH);
    const [isReady, setIsReady] = useState(false);

    const isCongrats = phase === CONGRATS;
    const src = isCongrats ? bundle.congratsVideo : bundle.splashVideo;

    const advance = useCallback(() => {
        if (isCongrats) {
            if (bundle.splashVideo) {
                setIsReady(false);
                setPhase(SPLASH);
            } else {
                onContinue();
            }
        } else {
            onContinue();
        }
    }, [isCongrats, bundle.splashVideo, onContinue]);

    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, []);

    useEffect(() => {
        if (!src) onContinue();
    }, [src, onContinue]);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const playPromise = video.play();
        if (playPromise?.catch) {
            playPromise.catch(() => setIsReady(true));
        }
    }, [phase]);

    useEffect(() => {
        if (!isCongrats) return undefined;
        const timer = setTimeout(advance, CONGRATS_MAX_MS);
        return () => clearTimeout(timer);
    }, [isCongrats, advance]);

    if (!src) return null;

    return (
        <div
            className={styles.overlay}
            style={{
                '--splash-button': bundle.theme.splashButton,
                '--splash-button-glow': bundle.theme.splashButtonGlow,
                '--splash-button-text': bundle.theme.splashButtonText,
                '--splash-page': bundle.theme.page,
                '--splash-backdrop': bundle.theme.splashBackdrop,
            }}
        >
            <video
                key={phase}
                ref={videoRef}
                className={`${styles.video} ${isReady ? styles.videoVisible : ''}`}
                src={src}
                autoPlay
                muted
                loop={!isCongrats}
                playsInline
                preload="auto"
                onCanPlay={() => setIsReady(true)}
                onEnded={isCongrats ? advance : undefined}
                onError={advance}
            />

            {/* Logo on top of the video - only for bundles that set `logo` in utils/bundles.js */}
            {bundle.logo && (
                <img className={styles.logo} src={bundle.logo} alt="Jazz" />
            )}

            {!isCongrats && (
                <div className={styles.ctaBar}>
                    <button type="button" className={styles.cta} onClick={onContinue}>
                        {bundle.splashCta || 'SEE MY MISSIONS →'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default BundleSplash;